<template>
  <div class="jxs-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="通知状态">
              <el-select v-model="searchForm.mark" style="width: 120px" filterable clearable @keyup.enter.native="Search">
                <el-option label="未读" :value="0" />
                <el-option label="已读" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%"
                  @row-click="openDetails"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    align="center"
                    width="50"
                  />
                  <el-table-column
                    min-width="140"
                    show-overflow-tooltip
                  >
                    <template slot="header">
                      <el-button icon="el-icon-delete" size="mini" @click="delData">删除</el-button>
                      <el-button icon="el-icon-check" size="mini" @click="readData">标记已读</el-button>
                      <el-button icon="el-icon-document-checked" size="mini" @click="allReadData">全部已读</el-button>
                    </template>
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.isread===0" size="mini" :disable-transitions="true" type="danger">未读</el-tag>
                      <span :style="scope.row.isread===0?'margin-left: 6px;font-weight: bold':''">{{ scope.row.title }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="通知时间"
                    width="160"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="通知详情"
      :visible.sync="dialogVisible"
      width="40%">
      <div style="font-size: 16px;color:#333333;margin-bottom: 10px;font-weight: 400;">{{ info.title }}</div>
      <div style="color:#999999;margin-bottom: 10px">{{ info.time }}</div>
      <div style="border-top: 1px solid #F2F6FC;padding: 10px 0;line-height:30px;" v-html="info.content"/>
      <div v-if="info.type!==1" class="tcf-tip">
        <p v-if="info.type===0&&!issplit">温馨提示：这里是订单的基本信息，点击订单号可查看订单详情</p>
        <p v-if="info.type===0">订单号：<span style="color:#409EFF;cursor: pointer" @click="goOrder(info)"><i class="el-icon-document" /> {{ info.ordernum }}</span></p>
        <p v-if="info.type===0&&info.produnum!==null&&info.produnum!==''&&info.produnum!==undefined">生产单号：{{ info.produnum }}</p>
        <p v-if="info.type===0&&info.role===0">经销商：{{info.delname}}</p>
        <p v-if="info.type===0">详细地址：{{ info.address }}</p>
        <p v-if="ispzqr"><router-link to="/work/sksq"><i class="el-icon-paperclip" /> 点击打开凭证确认</router-link></p>
        <p v-if="isshhf"><router-link to="/work/delshhf"><i class="el-icon-paperclip" /> 点击打开售后回访</router-link></p>
        <p v-if="isyjzpfd"><router-link to="/work/yjzpfdzh"><i class="el-icon-paperclip" /> 点击打开业绩/支票返点</router-link></p>
        <p v-if="isshpkhz"><router-link to="/work/shpkzh"><i class="el-icon-paperclip" /> 点击打开售后赔款</router-link></p>
        <p v-if="isbbj"><router-link to="/work/bbjzh"><i class="el-icon-paperclip" /> 点击打开报备金</router-link></p>
        <p v-if="info.type===7"><router-link :to="`/work/delclient/${info.dataid}`"><i class="el-icon-paperclip" /> 点击打开客户详情</router-link></p>
        <p v-if="info.type===10"><router-link to="/work/delzhgl"><i class="el-icon-paperclip" /> 点击打开账户管理</router-link></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getUserWorkNitoceList, UserWorkNitoceOper } from '@/api/pub'

export default {
  name: 'WorkNotice',
  computed: {
    user: getUser
  },
  data() {
    return {
      searchForm: {
        mark: null,
        search: ''
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dialogVisible: false,
      info: {},
      multipleSelection: [],
      issplit: false,
      ispzqr: false,
      isshhf: false,
      isyjzpfd: false,
      isshpkhz: false,
      isbbj: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    Search() {
      if (this.searchForm.search != null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      let userid = null
      if (this.user.rank === 1) {
        userid = this.user.userid
      } else {
        userid = this.user.dUserid
      }
      const data = {
        userid: userid,
        role: this.user.rank,
        content: this.searchForm.search,
        mark: this.searchForm.mark,
        page: this.currentPage,
        limit: this.pageSize
      }
      getUserWorkNitoceList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    delData() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('此操作将永久删除此' + this.multipleSelection.length + '项通知, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = []
          for (const d of this.multipleSelection) {
            ids.push(d.id)
          }
          this.SubOper(0, ids.join(','))
        }).catch(() => {})
      } else {
        this.$message.error('请勾选需要删除的通知')
      }
    },
    readData() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('此操作将此' + this.multipleSelection.length + '项通知设为已读, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = []
          for (const d of this.multipleSelection) {
            ids.push(d.id)
          }
          this.SubOper(1, ids.join(','))
          for (const row of this.tableData) {
            for (const id of ids) {
              if (row.id === id) {
                row.isread = 1
                break
              }
            }
          }
        }).catch(() => {})
      } else {
        this.$message.error('请勾选需要已读的通知')
      }
    },
    allReadData() {
      this.$confirm('此操作将所有通知设为已读, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.SubOper(2, '')
      }).catch(() => {})
    },
    openDetails(row) {
      row.isread = 1
      this.info = row
      this.issplit = false
      this.ispzqr = false
      this.isshhf = false
      this.isyjzpfd = false
      this.isshpkhz = false
      this.isbbj = false
      if (this.info.title.indexOf('拆分') >= 0) {
        this.issplit = true
      }
      if (this.info.title.indexOf('打款凭证待确认') >= 0) {
        this.ispzqr = true
      }
      if (this.info.title.indexOf('售后回访') >= 0) {
        this.isshhf = true
      }
      if (this.info.title.indexOf('业绩/支票返点') >= 0) {
        this.isyjzpfd = true
      }
      if (this.info.title.indexOf('售后赔款') >= 0) {
        this.isshpkhz = true
      }
      if (this.info.title.indexOf('报备金') >= 0) {
        this.isbbj = true
      }
      this.dialogVisible = true
      this.SubOper(1, row.id)
    },
    SubOper(type, ids) {
      let userid = null
      if (this.user.rank === 1) {
        userid = this.user.userid
      } else {
        userid = this.user.dUserid
      }
      const data = {
        userid: userid,
        role: this.user.rank,
        type: type, // 0删除   1已读   2全部已读
        ids: ids
      }
      UserWorkNitoceOper(data).then(response => {
        if (type === 0) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getData()
        } else if (type === 2) {
          this.getData()
        }
      }).catch(() => {})
    },
    goOrder(row) {
      if(!this.issplit) {
        this.dialogVisible = false
        if (row.role === 0) {
          this.$router.push({
            path: `/work/order/${row.dataid}`
          })
        } else {
          this.$router.push({
            path: `/work/delorder/${row.dataid}`
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jxs-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
